// extracted by mini-css-extract-plugin
export var labelWrapper = "_ge-0";